import React from 'react'
import styles from './feed-next-page-link.module.scss'
import { shouldLoadFeedPageInPlace } from 'lib/feedPagination'

// The feed's real next-page link. The href is what crawlers follow (Googlebot
// renders but does not scroll, so without this a feed ends at its first
// batch); the click handler keeps humans in the seamless in-place flow.
export default function FeedNextPageLink({
    href,
    onLoadMore,
    isLoading,
}: {
    href: string
    onLoadMore: () => void
    isLoading?: boolean
}) {
    if (isLoading) return null

    const onClick = (ev: React.MouseEvent) => {
        if (!shouldLoadFeedPageInPlace(ev)) return
        ev.preventDefault()
        ev.stopPropagation()
        onLoadMore()
    }

    return (
        <div className={styles.feedNextPage}>
            <a href={href} rel="next" onClick={onClick}>
                Show more
            </a>
        </div>
    )
}
